<template>
  <div id="user-login">
    <button v-if="!isLoggedIn" class="btn btn-link user-welcome fst-italic fw-medium text-nowrap text-white"
            data-bs-target="#stripeLogin"
            data-bs-toggle="modal">
      <span>{{ trans.textButton }}</span>

    </button>

    <div v-else
         class="d-flex align-items-center">
      <button
        class="btn d-flex align-items-center p-0 ms-8 me-16 mx-xl-0"
        @click="goToUser()"
      >
        <span class="user-bg p-12 p-lg-20">
          <span class="icon icon-user text-lg text-white"></span>
        </span>
        <span :title="user.name"
              class="user-name text-white text-nowrap m-0 ps-12"
        >{{ trans.userHi ?? 'Hi' }}, {{ user.name }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import api from '@assets/js/front/checkout/api';

export default {
  name: 'VLoginButton',
  props: {
    trans: {
      required: true,
    },
    locale: {
      required: true,
      type: String,
    },
    subscriptionUrl: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      isLoggedIn: false,
      user: {},
    };
  },
  async mounted() {
    this.isLoggedIn = await api.auth.check();

    if (!!this.isLoggedIn) {
      this.user = await api.user.retrieve();
    }
  },
  methods: {
    async goToUser() {
      window.location.href = !!this.subscriptionUrl ? this.subscriptionUrl : '/subscriber-information';
    },
  },
};
</script>

<style lang="scss" scoped>
#user-login {
  .user-bg {
    background-color: rgba(255, 255, 255, 0.02);
    border: 1px solid #262626;
    border-radius: 100%;
  }
}
</style>
